/**
 * @fileoverview Absolute URLs for the landing page images.
 *
 * The files are hosted on S3 so multi-MB binaries stay out of the repo. Override the base
 * with `NEXT_PUBLIC_LANDING_ASSETS_BASE_URL`; whatever host is used must be listed in
 * `images.remotePatterns` in `next.config.ts` or `next/image` rejects it.
 */
export const LANDING_ASSETS_DEFAULT_BASE_URL =
  'https://ss-leagues.s3.amazonaws.com/Attend%20Assets';

const baseUrl = (
  process.env.NEXT_PUBLIC_LANDING_ASSETS_BASE_URL || LANDING_ASSETS_DEFAULT_BASE_URL
).replace(/\/+$/, '');

/** Joins the configured base URL with an asset file name. */
export function landingAssetUrl(fileName: string): string {
  return `${baseUrl}/${fileName}`;
}

export const landingAssets = {
  heroMockup: landingAssetUrl('hat-trick-plan.png'),
  storyTexture: landingAssetUrl('texture-teal.jpg'),
  attendLogo: landingAssetUrl('flex-mark.png'),
  // Approved social card: the hero mockup doubles as `og:image` (owner-approved, not a
  // placeholder). Its aspect ratio is not the 1200x630 that social platforms crop to, so
  // shared cards will be cropped — accepted tradeoff rather than a dedicated asset.
  ogImage: landingAssetUrl('hat-trick-plan.png'),
};
